import { render, staticRenderFns } from "./appointmentByEmployeeTypesSetupList.vue?vue&type=template&id=0a868d07&"
import script from "./appointmentByEmployeeTypesSetupList.vue?vue&type=script&lang=js&"
export * from "./appointmentByEmployeeTypesSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports